import { getBaseUrl } from './utils.js'

let baseUrl = getBaseUrl()

export default {
  getChildrenByParentId: baseUrl + '/api/breadcrumbs/menu/',
  getMenuChildrenByParentId: baseUrl + '/api/mobile/menu/',
  getMoreCustomerNewsItems: baseUrl + '/api/customerNews/',
  getMoreCustomerServiceItems: baseUrl + '/api/customerService/',
  getMoreSearchItems: baseUrl + '/api/searchItems/',
  getContactUsData: baseUrl + '/api/contactus/',
  postFeedback: baseUrl + '/api/userfeedback/',
  postContactUsForm: baseUrl + '/api/contactus/contact/',
  getAutocompleteItems: baseUrl + '/api/autocompleteItems/',
  getAutocompleteItemsFaq: baseUrl + '/api/autocompleteItemsFaq/',
  getAutocompleteItemsProjects: baseUrl + '/api/autocompleteItemsProjects/',
  postCreateUserForm: baseUrl + '/api/user/create/',

  //common
  getCurrentSession: baseUrl + '/api/mypages/user/getcurrentsession/',
  getCustomerServiceAdminImpersonate: baseUrl + '/api/users/impersonate',
  postCustomerServiceAdminImpersonate: baseUrl + '/api/users/impersonate',

  //common - post
  postExtendCurrentSession: baseUrl + '/api/mypages/user/refreshsession/',
  postTrackAppInsight: baseUrl + '/api/telemetry/trackevent/',

  //mypages
  getConsumptionChartData: baseUrl + '/api/mypages/energy/consumption/',
  getTemperatureChartData: baseUrl + '/api/mypages/metering/temperature/',
  getEffectChartData: baseUrl + '/api/mypages/energy/power/{id}',
  getEffectPriceCalculationData: baseUrl + '/api/mypages/myagreementsprices/pricecalculation/',
  // /api/mypages/energy/power/{deliverySiteId}

  // getConsumptionData: baseUrl + '/api/consumption/',
  getThirdPartyConsents: baseUrl + '/api/mypages/consentthirdparty/consents/',
  putThirdPartyConsents: baseUrl + '/api/mypages/consentthirdparty/consents/',
  getTableAccessibleMockData: baseUrl + '/api/mypages/tableAccessiblemockdata/',
  getMeterReadingsData: baseUrl + '/api/mypages/metering/readings/{id}/',
  getDeliverySitesData: baseUrl + '/api/mypages/deliverysites/table/',
  getOptInOutInformation: baseUrl + '/api/mypages/mydetails/contactsubscriptions',
  putOptInOutInformation: baseUrl + '/api/mypages/mydetails/contactsubscriptions',
  postDeliverySiteCustomName: baseUrl + '/api/mypages/deliverysites/{id}/customname',
  deleteDeliverySiteCustomName: baseUrl + '/api/mypages/deliverysites/{id}/customname',

  getPowerOutageNotificationTableData: baseUrl + '/api/mypages/poweroutagenotifications/table/',
  getDeliverySites: baseUrl + '/api/mypages/deliverysites/',
  getConsumptionData: baseUrl + '/api/mypages/metering/summary/',
  getConsumptionDataCombined: baseUrl + '/api/mypages/metering/summary/',
  getDeliverySiteInformation: baseUrl + '/api/mypages/deliverysites/',
  getCustomerDetails: baseUrl + '/api/mypages/mydetails/address/',
  getContactDetails: baseUrl + '/api/mypages/mydetails/contactinformation/',
  getAccountSettingsEmailData: baseUrl + '/api/mypages/mydetails/username/',
  getAccountSettingsPasswordData: baseUrl + '/api/mypages/account/settings/password/',
  putContactInformationConfirmation: baseUrl + '/api/mypages/mydetails/contactinformationconfirmation/',

  postInvoiceSendMethodDataEInvoice: baseUrl + '/api/mypages/invoices/invoiceconfiguration/updatesendmethodeinvoice/',
  postInvoiceSendMethodEmail: baseUrl + '/api/mypages/invoices/invoiceconfiguration/updatesendmethodemail/',
  postInvoiceSendMethodPostal: baseUrl + '/api/mypages/invoices/invoiceconfiguration/updatesendmethodpostal/',

  getInvoiceSendMethodData: baseUrl + '/api/mypages/invoices/invoiceconfiguration/{id}/',
  getInvoiceData: baseUrl + '/api/mypages/invoices/{id}/',

  getCreditPaymentsTableData: baseUrl + '/api/mypages/creditpayments/table/{id}/',
  getPossiblePayoutsData: baseUrl + '/api/mypages/customerpayment/possiblepayouts/',
  postPossiblePayouts: baseUrl + '/api/mypages/customerpayment/createpayouts/',
  getBankAccountDetailsData: baseUrl + '/api/mypages/customerpayment/bankaccount/',
  postBankAccountDetails: baseUrl + '/api/mypages/customerpayment/savebankaccount/',
  getBankAccountValidation: baseUrl + '/api/mypages/customerpayment/bankaccountvalidation/',

  getOverviewInvoiceData: baseUrl + '/api/mypages/invoices/overview/',
  getOverviewPowerOutageData: baseUrl + '/api/mypages/poweroutagenotifications/overview/',
  //getPriceSupportData: baseUrl + '/api/mypages/customerpayment/allelectricitycompensations/',
  getPriceSupportData: baseUrl + '/api/mypages/customerpayment/electricitycompensation/',

  getSearchAddress: baseUrl + '/api/mypages/invoices/searchAddress/query/{address}',
  getInvoiceSettingsData: baseUrl + '/api/mypages/invoices/{id}/address/',
  getPowerOutageNotificationsData: baseUrl + '/api/mypages/poweroutagenotifications/',
  getRealTimeMeasurementData: baseUrl + '/api/mypages/deliverysites/{id}/realtimemeasurement',
  getPriceCalculationData: baseUrl + '/api/mypages/myagreementsprices/pricecalculation/',
  getAgreementDetailsData: baseUrl + '/api/mypages/myagreementsprices/agreementdetails/',

  //Handle groups
  getGroupsData: baseUrl + '/api/mypages/deliverysitegroups/{id}',
  postGroupsData: baseUrl + '/api/mypages/deliverysitegroups/{id}',
  deleteRemoveGroup: baseUrl + '/api/mypages/deliverysitegroups/{id}',
  setGroupsOrder: baseUrl + '/api/mypages/deliverysitegroups/{id}/sort',

  //mypages - post
  postAccountSettingsEmail: baseUrl + '/api/mypages/mydetails/username/',
  postAccountSettingsPassword: baseUrl + '/api/mypages/mydetails/password/',
  postPowerOutageNotifications: baseUrl + '/api/mypages/poweroutagenotifications/',
  postPowerOutageNotificationsBatch: baseUrl + '/api/mypages/poweroutagenotifications/batch/',
  postRealTimeMeasurement: baseUrl + '/api/mypages/deliverysites/{id}/realtimemeasurement',
  postContactDetails: baseUrl + '/api/mypages/mydetails/contactinformation/',
  postActivateAutogiro: baseUrl + '/api/mypages/invoices/invoiceconfiguration/autogiro/apply/',
  postPollAutogiro: baseUrl + '/api/mypages/invoices/invoiceconfiguration/autogiro/poll/',
  getInitBankId: baseUrl + '/api/mypages/invoices/invoiceconfiguration/autogiro/init/',
  getCancelBankId: baseUrl + '/api/mypages/invoices/invoiceconfiguration/autogiro/cancel/',
  getQrImageBankId: baseUrl + '/api/mypages/invoices/invoiceconfiguration/autogiro/bankid/qrimage/',
  postSignAutogiro: baseUrl + '/api/mypages/invoices/invoiceconfiguration/autogiro/sign/',

  //mypages - delete
  deleteUserAccount: baseUrl + '/api/mypages/mydetails/remove/',
  deleteRemoveAutogiro: baseUrl + '/api/mypages/invoices/invoiceconfiguration/autogiro/remove/{id}/',

  //energikonto
  getCustomers: baseUrl + '/api/mypages/customers/',
  removeAccount: baseUrl + '/api/mypages/customers/delegation/remove',
  addAccount: baseUrl + '/api/mypages/customers/delegation/add',
  postCheckSignatory: baseUrl + '/api/mypages/customers/delegation/checksignatory/',
  postConnectAccount: baseUrl + '/api/mypages/customers/connectaccount/',
  appInsight: baseUrl + '/api/mypages/energy/tab',

  //Projektkartan
  getProjectMapData: baseUrl + '/api/projectmapdata',

  getAccessPowerTariff: baseUrl + '/api/mypages/powertariff/overview/',
  getPowerTariffCostComparison: baseUrl + '/api/mypages/powertariff/costcomparison/{id}/',

  // Imd
  postImdUserInput: baseUrl + '/api/imd/'
}
